module.exports = __webpack_public_path__ + "static/media/Morphic3DPic1.5eb0f6a0.png";